module.exports = __webpack_public_path__ + "static/media/InventoryMgmt.33ed078e.svg";